// extracted by mini-css-extract-plugin
export var sliderStyle = "sr_chapter_card_nav-module--sliderStyle--Hzolm";
export var wrapperStyle = "sr_chapter_card_nav-module--wrapperStyle--FS+im";